import * as Website from '../../Config/Website.js';
import * as ScrollBlur from '../../Modules/ScrollBlur.js';


const preinit = () => {

}

const init = () => {
  ScrollBlur.init();
}

const pageChanged = () => {
  ScrollBlur.init();
}

const resize = () => {
}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  pageChanged,
  resize,
  resizeW,
  scroll,
  load
}